export default __webpack_public_path__ + "static/media/gp-title-en.4da0ea44.webp";